import PropertyInfoBox from "components/PropertyInfoBox";
import { PROJECT_STATUS } from "constants/status";
import { useFormattedMessage } from "hooks";

const messages = {
    yourDigitalShares: "property_your_digital_shares",
};

const InfoBox = ({
    isTypeClub,
    isTypeClubWithShare,
    status,
    projectData,
    isLoggedIn,
    VIPUser,
    fundingPercentage,
    investedAmount,
    fundingNews,
    infoBox,
    isMarketplace,
    isMarketplacePaused,
    isPropertyInfoBoxValidStatus,
    isSharesSectionVisible,
}) => {
    const { formatMessage } = useFormattedMessage();

    return isTypeClub && isTypeClubWithShare && status === PROJECT_STATUS.FUNDING_ACTIVE ? (
        <div className="property-info-box-container">
            {projectData && (
                <PropertyInfoBox
                    isLoggedIn={isLoggedIn}
                    VIPUser={VIPUser}
                    status={status}
                    fundingPercentage={fundingPercentage}
                    investedAmount={investedAmount}
                    fundingNews={fundingNews}
                />
            )}
        </div>
    ) : ((isTypeClub && !isMarketplace && !isMarketplacePaused) || status === PROJECT_STATUS.SUCCESSFULLY_PAID_BACK) &&
      infoBox ? (
        <section
            className={`item-block club-item-block border-radius funding ${
                status === PROJECT_STATUS.SUCCESSFULLY_PAID_BACK ? "bg-light-green" : "bg-primary-light"
            }`}
        >
            <div
                dangerouslySetInnerHTML={{
                    __html: infoBox.infoBoxTitleHtml,
                }}
            />
            <div
                className="club-css-div"
                dangerouslySetInnerHTML={{
                    __html: infoBox.infoBoxContentHtml,
                }}
            />
            <div
                className="club-css-div"
                dangerouslySetInnerHTML={{
                    __html: infoBox.infoBoxUrlHtml,
                }}
            />
        </section>
    ) : !isMarketplace && isPropertyInfoBoxValidStatus ? (
        <div className="property-info-box-container">
            {projectData && (
                <PropertyInfoBox
                    isLoggedIn={isLoggedIn}
                    VIPUser={VIPUser}
                    status={status}
                    fundingPercentage={fundingPercentage}
                    investedAmount={investedAmount}
                    fundingNews={fundingNews}
                />
            )}
        </div>
    ) : (
        isLoggedIn &&
        !isSharesSectionVisible &&
        isPropertyInfoBoxValidStatus && (
            <div className="property-info-box-container">
                <h3 className="my-0">{formatMessage(messages.yourDigitalShares)}</h3>
                {projectData && (
                    <PropertyInfoBox
                        isLoggedIn={isLoggedIn}
                        VIPUser={VIPUser}
                        status={status}
                        fundingPercentage={fundingPercentage}
                        investedAmount={investedAmount}
                        fundingNews={fundingNews}
                    />
                )}
            </div>
        )
    );
};

export default InfoBox;
